module.exports = __webpack_public_path__ + "static/media/sss-auto-vial.5ce1ecd3.svg";